import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { AgGridModule } from "ag-grid-angular";
import { CKEditorModule } from "ngx-ckeditor";
import { ColorPickerModule } from "ngx-color-picker";
import { DndModule } from "ngx-drag-drop";
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { ConfirmationModalComponent } from "./confirmation-modal/confirmation-modal.component";
import { ButtonPropertyComponent } from "./drag-drop-content/elements/button-property/button-property.component";
import { ButtonComponent } from "./drag-drop-content/elements/button/button.component";
import { CheckboxPropertyComponent } from "./drag-drop-content/elements/checkbox-property/checkbox-property.component";
import { CheckboxComponent } from "./drag-drop-content/elements/checkbox/checkbox.component";
import { CurrentElementComponent } from "./drag-drop-content/elements/current-element/current-element.component";
import { DropdownPropertyComponent } from "./drag-drop-content/elements/dropdown-property/dropdown-property.component";
import { DropdownComponent } from "./drag-drop-content/elements/dropdown/dropdown.component";
import { FormDesignPropertyComponent } from "./drag-drop-content/elements/form-design-property/form-design-property.component";
import { InputPropertyComponent } from "./drag-drop-content/elements/input-property/input-property.component";
import { InputComponent } from "./drag-drop-content/elements/input/input.component";
import { ListPropertyComponent } from "./drag-drop-content/elements/list-property/list-property.component";
import { ListComponent } from "./drag-drop-content/elements/list/list.component";
import { BtnDeleteRowRendererComponent } from "./drag-drop-content/elements/list/btn-delete-row-renderer.component";
import { PicturePropertyComponent } from "./drag-drop-content/elements/picture-property/picture-property.component";
import { PictureComponent } from "./drag-drop-content/elements/picture/picture.component";
import { RadiosPropertyComponent } from "./drag-drop-content/elements/radios-property/radios-property.component";
import { RadiosComponent } from "./drag-drop-content/elements/radios/radios.component";
import { SeparatorPropertyComponent } from "./drag-drop-content/elements/separator-property/separator-property.component";
import { SeparatorComponent } from "./drag-drop-content/elements/separator/separator.component";
import { SocialPropertyComponent } from "./drag-drop-content/elements/social-property/social-property.component";
import { SocialComponent } from "./drag-drop-content/elements/social/social.component";
import { SpacerPropertyComponent } from "./drag-drop-content/elements/spacer-property/spacer-property.component";
import { SpacerComponent } from "./drag-drop-content/elements/spacer/spacer.component";
import { TextPropertyComponent } from "./drag-drop-content/elements/text-property/text-property.component";
import { TextComponent } from "./drag-drop-content/elements/text/text.component";
import { TextareaPropertyComponent } from "./drag-drop-content/elements/textarea-property/textarea-property.component";
import { TextareaComponent } from "./drag-drop-content/elements/textarea/textarea.component";
import { UploaderPropertyComponent } from "./drag-drop-content/elements/uploader-property/uploader-property.component";
import { UploaderComponent } from "./drag-drop-content/elements/uploader/uploader.component";
import { FontOptionsComponent } from "./font-options/font-options.component";
import { HtmlEditorComponent } from "./html-editor/html-editor.component";
import { I18nService } from "./i18n.service";
import { PreviewHtmlComponent } from "./preview-html/preview-html.component";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { SharedModule } from "../user-management/shared/shared.module";
import { MatSelectFilterModule } from "mat-select-filter";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    DndModule,
    CKEditorModule,
    ColorPickerModule,
    TranslateModule.forChild(),
    DropzoneModule,
    AgGridModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDialogModule,
    MatButtonModule,
    SharedModule,
    AgGridModule,
    MatSelectFilterModule
  ],
  exports: [
    SafeHtmlPipe,
    FontOptionsComponent,
    TextComponent,
    SeparatorComponent,
    ButtonComponent,
    PictureComponent,
    SocialComponent,
    CurrentElementComponent,
    TextPropertyComponent,
    PicturePropertyComponent,
    ButtonPropertyComponent,
    SeparatorPropertyComponent,
    SocialPropertyComponent,
    HtmlEditorComponent,
    CheckboxComponent,
    CheckboxPropertyComponent,
    RadiosComponent,
    DropdownComponent,
    InputComponent,
    TextareaComponent,
    SpacerComponent,
    SpacerPropertyComponent,
    TextareaPropertyComponent,
    RadiosPropertyComponent,
    DropdownPropertyComponent,
    InputPropertyComponent,
    FormDesignPropertyComponent,
    UploaderComponent,
    UploaderPropertyComponent,
    ListComponent,
    ListPropertyComponent
  ],
  declarations: [
    SafeHtmlPipe,
    FontOptionsComponent,
    ConfirmationModalComponent,
    TextComponent,
    SeparatorComponent,
    ButtonComponent,
    PictureComponent,
    SocialComponent,
    CurrentElementComponent,
    TextPropertyComponent,
    PicturePropertyComponent,
    ButtonPropertyComponent,
    SeparatorPropertyComponent,
    SocialPropertyComponent,
    HtmlEditorComponent,
    PreviewHtmlComponent,
    CheckboxComponent,
    CheckboxPropertyComponent,
    RadiosComponent,
    DropdownComponent,
    InputComponent,
    TextareaComponent,
    SpacerComponent,
    SpacerPropertyComponent,
    TextareaPropertyComponent,
    RadiosPropertyComponent,
    DropdownPropertyComponent,
    InputPropertyComponent,
    FormDesignPropertyComponent,
    UploaderComponent,
    UploaderPropertyComponent,
    ListComponent,
    ListPropertyComponent,
    BtnDeleteRowRendererComponent
  ],
  entryComponents: [ConfirmationModalComponent],
  providers: [I18nService],
})
export class UIBuilderSharedModule {}
